export default __webpack_public_path__ + "static/media/sunflowerBoba.f9030936.jpg";